export const checkIsMobile = () => {
  const { userAgent } = navigator;
  const regex = /mobile|android|webos|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini/i;
  return regex.test(userAgent);
};
